"use strict";
/*
 * Created on 03 01 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Abstract representation of item (product) re-priced during the release. This is entity with its own database collection.
 * Release item holds reference and optimal prices calculated for a product during the release.
 *
 * @author JMe
 * @author Radek Beran
 */


var AbstractReleaseItem =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(AbstractReleaseItem, _DomainObject_1$Domai);

  /**
   * @param id identifier of release item
   * @param releaseId internal id of release
   * @param productId internal id of internal product
   * @param productExternalId external id of internal product
   * @param productName name of product
   * @param categoryIds product categories to which product belongs (product category tree, same as {@link Product.categoryIds}
   * @param readonly release item should be readonly (attribute can be set also later in release process, eg. based on an event)
   * @param uploaded flag indicating whether this item has been created based on a record of uploaded file.
   * @param exported flag indicating whether this item should be/has been exported to external system
   * @param exportedDate date when this item has been exported
   * (last date for some release types where the item can be exported multiple times).
   * {@link ExportedPriceListRow}s will maintain the whole export history.
   * @param validationResult validation messages (alerts)
   */
  function AbstractReleaseItem(id, releaseId, productId, productExternalId, productName, categoryIds, readonly, uploaded, exported, exportedDate, validationResult) {
    var _this;

    _classCallCheck(this, AbstractReleaseItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbstractReleaseItem).call(this));
    _this.id = id;
    _this.releaseId = releaseId;
    _this.productId = productId;
    _this.productExternalId = productExternalId;
    _this.productName = productName;
    _this.categoryIds = categoryIds;
    _this.readonly = readonly;
    _this.uploaded = uploaded;
    _this.exported = exported;
    _this.exportedDate = exportedDate;
    _this.validationResult = validationResult;
    return _this;
  }

  _createClass(AbstractReleaseItem, [{
    key: "withMessage",
    value: function withMessage(message) {
      return this.copy('validationResult', this.validationResult.addObjectIfNotPresent(message));
    }
  }]);

  return AbstractReleaseItem;
}(DomainObject_1.DomainObject);

exports.AbstractReleaseItem = AbstractReleaseItem;